"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeCheckoutMutation = exports.createCheckoutPaymentMutation = exports.removeCheckoutPromoCode = exports.addCheckoutPromoCode = exports.updateCheckoutShippingMethodMutation = exports.updateCheckoutShippingAddressMutation = exports.updateCheckoutBillingAddressMutation = exports.updateCheckoutBillingAddressWithEmailMutation = exports.createCheckoutMutation = exports.updateCheckoutLineMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const checkout_1 = require("../fragments/checkout");
const payment_1 = require("../fragments/payment");
const user_1 = require("../fragments/user");

exports.updateCheckoutLineMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation UpdateCheckoutLine($checkoutId: ID!, $lines: [CheckoutLineInput]!) {
    checkoutLinesUpdate(checkoutId: $checkoutId, lines: $lines) {
      checkout {
        ...Checkout
      }
      errors: checkoutErrors {
        ...CheckoutError
      }
    }
  }
`;
exports.createCheckoutMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation CreateCheckout($checkoutInput: CheckoutCreateInput!) {
    checkoutCreate(input: $checkoutInput) {
      errors: checkoutErrors {
        ...CheckoutError
      }
      checkout {
        ...Checkout
      }
    }
  }
`;
exports.updateCheckoutBillingAddressWithEmailMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation UpdateCheckoutBillingAddressWithEmail(
    $checkoutId: ID!
    $billingAddress: AddressInput!
    $email: String!
  ) {
    checkoutBillingAddressUpdate(
      checkoutId: $checkoutId
      billingAddress: $billingAddress
    ) {
      errors: checkoutErrors {
        ...CheckoutError
      }
      checkout {
        ...Checkout
      }
    }
    checkoutEmailUpdate(checkoutId: $checkoutId, email: $email) {
      checkout {
        ...Checkout
      }
      errors: checkoutErrors {
        code
        field
        message
      }
    }
  }
`;
exports.updateCheckoutBillingAddressMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation UpdateCheckoutBillingAddress(
    $checkoutId: ID!
    $billingAddress: AddressInput!
  ) {
    checkoutBillingAddressUpdate(
      checkoutId: $checkoutId
      billingAddress: $billingAddress
    ) {
      errors: checkoutErrors {
        ...CheckoutError
      }
      checkout {
        ...Checkout
      }
    }
  }
`;
exports.updateCheckoutShippingAddressMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation UpdateCheckoutShippingAddress(
    $checkoutId: ID!
    $shippingAddress: AddressInput!
    $email: String!
  ) {
    checkoutShippingAddressUpdate(
      checkoutId: $checkoutId
      shippingAddress: $shippingAddress
    ) {
      errors: checkoutErrors {
        ...CheckoutError
      }
      checkout {
        ...Checkout
      }
    }
    checkoutEmailUpdate(checkoutId: $checkoutId, email: $email) {
      checkout {
        ...Checkout
      }
      errors: checkoutErrors {
        ...CheckoutError
      }
    }
  }
`;
exports.updateCheckoutShippingMethodMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation UpdateCheckoutShippingMethod(
    $checkoutId: ID!
    $deliveryType: String
    $deliverySchedules: [ShippingDeliveryScheduleInput]
    $note: String
  ) {
    checkoutShippingMethodUpdate(
      checkoutId: $checkoutId
      deliveryType: $deliveryType
      deliverySchedules: $deliverySchedules
      note: $note
    ) {
      checkout {
        ...Checkout
      }
      errors: checkoutErrors {
        ...CheckoutError
      }
    }
  }
`;
exports.addCheckoutPromoCode = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation AddCheckoutPromoCode($checkoutId: ID!, $promoCode: String!) {
    checkoutAddPromoCode(checkoutId: $checkoutId, promoCode: $promoCode) {
      checkout {
        ...Checkout
      }
      errors: checkoutErrors {
        ...CheckoutError
      }
    }
  }
`;
exports.removeCheckoutPromoCode = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation RemoveCheckoutPromoCode($checkoutId: ID!, $promoCode: String!) {
    checkoutRemovePromoCode(checkoutId: $checkoutId, promoCode: $promoCode) {
      checkout {
        ...Checkout
      }
      errors: checkoutErrors {
        ...CheckoutError
      }
    }
  }
`;
exports.createCheckoutPaymentMutation = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  ${payment_1.paymentFragment}
  ${payment_1.paymentErrorFragment}
  mutation CreateCheckoutPayment(
    $checkoutId: ID!
    $paymentInput: PaymentInput!
  ) {
    checkoutPaymentCreate(checkoutId: $checkoutId, input: $paymentInput) {
      checkout {
        ...Checkout
      }
      payment {
        ...Payment
      }
      errors: paymentErrors {
        ...PaymentError
      }
    }
  }
`;
exports.completeCheckoutMutation = graphql_tag_1.default`
  ${user_1.orderDetailFragment}
  ${checkout_1.checkoutErrorFragment}
  mutation CompleteCheckout($checkoutId: ID!, $checkoutNotes: [CheckoutNotesInput]) {
    checkoutComplete(checkoutId: $checkoutId, checkoutNotes: $checkoutNotes) {
      errors: checkoutErrors {
        ...CheckoutError
      }
      orders {
        ...OrderDetail
      }
      paymentRedirectUrl
    }
  }
`;
//# sourceMappingURL=checkout.js.map
